// JsFromRoutes CacheKey f8e1d02a5d4baa3e4ff4f7dd953f2062
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  import: /* #__PURE__ */ definePathHelper('post', '/candidates/import'),
  index: /* #__PURE__ */ definePathHelper('get', '/candidates'),
  create: /* #__PURE__ */ definePathHelper('post', '/candidates'),
  new: /* #__PURE__ */ definePathHelper('get', '/candidates/new'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/candidates/:id'),
}
